/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../../../../../utils/config';

export const STATIC_IP_CUSTOMERS_URL = `${API_URL}/staticip`;
